module.exports = __webpack_public_path__ + "f9a00bce73e421a3b78c98c3a4f1da83.ttf";